import { useState, useEffect } from "react";
import { FaBookDead, FaCalendarDay, FaCoins, FaEuroSign, FaHistory, FaHouseUser, FaHSquare, FaLandmark, FaPiggyBank, FaSun, FaWheelchair } from "react-icons/fa";
import Pager from "components/ui/controls/pager/pager";
import DetailCotisationsTNS from "./TNS/cotisations/detailCotisationsTNS";
import DetailDisponibleTNS from "../disponible/DetailDisponibleTNS";
import DetailImpot from "./DetailImpot";
import DetailIncapacite from "../prevoyance/DetailIncapacite";
import DetailInvaliditeTNS from "../prevoyance/TNS/DetailInvalidite";
import DetailDeces from "../prevoyance/DetailDeces";
import DetailPension from "../retraite/DetailPension";
import DetailRAM from "../retraite/DetailRAM";
import DetailSAMCRPCEN from "../retraite/DetailSAMCRPCEN";
import DetailTrimestre from "../retraite/DetailTrimestre";
import DetailDepart from "../retraite/DetailDepart";
import DetailReversion from "../retraite/DetailReversion";
import DetailTrimestreRU from "../retraite/DetailTrimestreRU";
import DetailTrimestreFP from "../retraite/DetailTrimestreFP";
import DetailTMI from "./DetailTMI";

const DetailTNSPageModal = (props) => {
  const [currentPage, setCurrentPage] = useState(1);

  const handleMenu = () => {
    let menu = [
      {
        isTitle: true,
        title: "",
      },
      {
        label: "Cotisations",
        icon: <FaEuroSign />,
        content: (
          <DetailCotisationsTNS
            Caisse={props.Caisse}
            DetailCotisations={props.DetailCotisations}
            DetailCSG={props.DetailCSG}
            DetailAssiette={props.DetailAssiette}
            TotalChargesSociales={props.TotalChargesSociales}
            Prenom={props.Prenom}
            ClientConjoint={props.ClientConjoint}
          />
        ),
      },
      {
        label: "Impôt",
        icon: <FaLandmark />,
        content: <DetailImpot DetailImpot={props.DetailImpot} DetailAssiette={props.DetailAssietteClient} DetailAssietteConjoint={props.DetailAssietteConjoint} />,
      },
      {
        label: "TMI",
        icon: <FaLandmark />,
        content: <DetailTMI DetailImpot={props.DetailImpot} DetailAssiette={props.DetailAssietteClient} DetailAssietteConjoint={props.DetailAssietteConjoint} />,
      },
      {
        label: "Disponibles",
        icon: <FaPiggyBank />,
        content: (
          <DetailDisponibleTNS
            InfosDisponible={props.InfosDisponible}
            InfosPerp={props.InfosPerp}
            ClientConjoint={props.ClientConjoint}
            GraphDisponible={props.GraphDisponible}
            GraphPerp={props.GraphPerp}
          />
        ),
      },
      {
        label: "Incapacité",
        icon: <FaHSquare />,
        content: <DetailIncapacite Outil={""} Affichage={""} TabIJ={props.TabIJ} GraphIJ={props.GraphIJ} />,
      },
      {
        label: "Invalidité",
        icon: <FaWheelchair />,
        content: <DetailInvaliditeTNS Outil={""} Affichage={""} TabInval={props.TabInval} GraphInval={props.GraphInval} />,
      },
      {
        label: "Décès",
        icon: <FaBookDead />,
        content: <DetailDeces Outil={""} Affichage={""} TabDeces={props.TabDeces} TabRente={props.TabRente} ClientConjoint={props.ClientConjoint} />,
      },
      {
        label: "Retraite",
        icon: <FaSun />,
        content: <DetailPension Outil={""} InfosPension={props.InfosRetraiteChoixDepart} />,
      },
      {
        label: "RAM",
        icon: <FaCoins />,
        content: <DetailRAM Outil={""} InfosRAM={props.InfosRetraiteChoixDepart?.InfosRetraite} />,
      },
      {
        label: "SAM CRPCEN",
        icon: <FaCoins />,
        content: <DetailSAMCRPCEN Outil={""} InfosRAM={props.InfosRetraiteChoixDepart?.InfosRetraite} />,
      },
      {
        label: "Trimestres tous régimes",
        icon: <FaHistory />,
        content: <DetailTrimestre Outil={""} InfosTrimestres={props.InfosRetraiteChoixDepart} />,
      },
      {
        label: "Trimestres régime général",
        icon: <FaHistory />,
        content: <DetailTrimestreRU Outil={""} InfosTrimestres={props.InfosRetraiteChoixDepart} />,
      },
      {
        label: "Trimestres fonction publique",
        icon: <FaHistory />,
        content: <DetailTrimestreFP Outil={""} InfosTrimestres={props.InfosRetraiteChoixDepart} />,
      },
      {
        label: "Départ",
        icon: <FaCalendarDay />,
        content: <DetailDepart Outil={""} InfosDepart={props.InfosRetraite} ClientConjoint={props.ClientConjoint} />,
      },
      {
        label: "Réversions",
        icon: <FaHouseUser />,
        content: <DetailReversion Outil={""} InfosDepart={props.InfosRetraite} />,
      },
    ];

    if (!Boolean(props.InfosRetraiteChoixDepart?.InfosRetraite?.RegimeUnifie)) {
      menu = menu.filter((k) => k.label !== "RAM");
    }
    if (!Boolean(props.InfosRetraiteChoixDepart?.InfosRetraite?.Crpcen?.General?.DetailSAMCrpcen)) {
      menu = menu.filter((k) => k.label !== "SAM CRPCEN");
    }
    if (Boolean(props.InfosRetraiteChoixDepart?.InfosRetraite?.Crpcen?.General?.DetailSAMCrpcen) && props.InfosRetraiteChoixDepart?.InfosRetraite?.Crpcen?.General?.SAM === 0) {
      menu = menu.filter((k) => k.label !== "SAM CRPCEN");
    }
   if (props.InfosRetraiteChoixDepart?.TabTrimestreDureeAssuranceFonctionPublique?.length === 0) {
      menu = menu.filter((k) => k.label !== "Trimestres fonction publique");
    }
    // if (context.state.StatutMarital !== "marie") {
    //   menu = menu.filter((k) => k.label !== "Réversions");
    // }

    if ("AccessRemExpress" in props) {
      menu = menu.slice(0, 5);
    }

    if (props.InfosRetraiteChoixDepart?.TotalPensionBrute === 0) {
      menu = menu.filter((k) => k.label !== "Départ");
      menu = menu.filter((k) => k.label !== "Réversions");
    }
    return menu;
  };
  useEffect(() => {
    setCurrentPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible]);
  return (
    <>
      <Pager
        withMenu
        pages={handleMenu()}
        page={currentPage}
        onPageChange={(page) => {
          setCurrentPage(page);
        }}
        navButtons={{
          previous: {},
          next: {},
          validate: {
            onClick: (evt) => {
              props.onClose();
            },
          },
        }}
      />
    </>
  );
};

export default DetailTNSPageModal;
